import { get, set } from 'lodash';
import * as actions from '../actions';
import produce from 'immer';
/**
 * 根据 id 获取目标节点
 * @param {array} options - 整个数据源的options
 * @param {string} id - 新请求回的数据
 * @returns {EntityPropertyOption|null} 返回目标节点item或者null
 */

function getTargetItem(options, id) {
  for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
    var item = options_1[_i];

    if (item.id === id) {
      return item;
    }

    if (item.children) {
      var deepItem = getTargetItem(item.children, id);

      if (deepItem) {
        return deepItem;
      }
    }
  }

  return null;
}

export var entityReducer = produce(function (draft, action) {
  var entity = action.entity,
      payload = action.payload;
  var entityId = entity && entity.id;

  if (entityId === undefined) {
    return;
  }

  if (draft[entityId] === undefined) {
    draft[entityId] = {};
  }

  var entityState = draft[entityId];

  switch (action.type) {
    case actions.ADD:
      entityState.requestStatus = 'pending';
      entityState.created = null;
      break;

    case actions.SEARCH:
    case actions.LOAD_NEXT_PAGE:
    case actions.GET:
    case actions.MODIFY:
    case actions.DELETE:
      entityState.requestStatus = 'pending';
      entityState.error = null;
      break;

    case actions.SEARCH_SUCCESS:
      entityState.requestStatus = 'success';
      entityState.result = payload.result || payload;
      entityState.paging = {
        page: payload.page,
        perPage: payload.perPage,
        totalNum: payload.totalNum,
        totalPage: payload.totalPage
      };
      break;

    case actions.LOAD_NEXT_PAGE_SUCCESS:
      entityState.requestStatus = 'success';
      entityState.result = (entityState.result || []).concat(payload.result);
      entityState.paging = {
        page: payload.page,
        perPage: payload.perPage,
        totalNum: payload.totalNum,
        totalPage: payload.totalPage
      };
      break;

    case actions.ADD_SUCCESS:
      entityState.requestStatus = 'success';
      entityState.created = payload;
      break;

    case actions.GET_SUCCESS:
      entityState.requestStatus = 'success';
      entityState.fields = payload;
      break;

    case actions.MODIFY_SUCCESS:
    case actions.DELETE_SUCCESS:
      entityState.requestStatus = 'success';
      break;

    case actions.SEARCH_FAILED:
      entityState.requestStatus = 'failed';
      entityState.error = payload;
      break;

    case actions.GET_FAILED:
      entityState.requestStatus = 'failed';
      entityState.fields = null;
      entityState.error = payload;
      break;

    case actions.LOAD_NEXT_PAGE_FAILED:
    case actions.ADD_FAILED:
    case actions.MODIFY_FAILED:
    case actions.DELETE_FAILED:
      entityState.requestStatus = 'failed';
      entityState.error = payload;
      break;

    case actions.ENTITY_SET_META:
      entityState.metainfo = payload;
      break;

    case actions.ENTITY_SET_FIELDS:
      entityState.fields = payload;
      break;

    case actions.LOAD_PROPERTY_OPTIONS_SUCCESS:
      var _a = action.fieldName,
          fieldName = _a === void 0 ? '' : _a;
      var path = fieldName.split('.').join('.properties.');

      if (!entityState.metainfo || !entityState.metainfo.properties) {
        return;
      }

      var entityProperty = get(entityState.metainfo.properties, path);

      if (!entityProperty) {
        return;
      }

      var propertySource = entityProperty.source,
          propertyOptions = entityProperty.options;

      if (!propertySource || !propertyOptions) {
        return;
      }

      var optionsData = void 0;

      switch (propertySource.dataType) {
        case 'treeNode':
          var targetItem = getTargetItem(propertyOptions, payload.id);

          if (targetItem) {
            targetItem.children = payload.children;
            optionsData = propertyOptions;
          } else {
            optionsData = payload.children;
          }

          break;

        case 'paging':
          optionsData = payload.result;
          break;

        default:
          optionsData = payload;
          break;
      }

      set(entityState.metainfo.properties, path + ".options", optionsData);
      break;

    case actions.LOAD_FILTER_OPTIONS_SUCCESS:
      if (!entityState.metainfo || !entityState.metainfo.filters) {
        return;
      }

      var entityFilter = get(entityState.metainfo.filters, action.fieldName || '');

      if (!entityFilter) {
        return;
      }

      var filterSource = entityFilter.source,
          filterOptions = entityFilter.options;

      if (!filterSource || !filterOptions) {
        return;
      }

      var filterOptionsData = void 0;

      switch (filterSource.dataType) {
        case 'treeNode':
          var targetItem = getTargetItem(filterOptions, payload.id);

          if (targetItem) {
            targetItem.children = payload.children;
            filterOptionsData = filterOptions;
          } else {
            filterOptionsData = payload.children;
          }

          break;

        case 'paging':
          filterOptionsData = payload.result;
          break;

        default:
          filterOptionsData = payload;
          break;
      }

      set(entityState.metainfo.filters, action.fieldName + ".options", filterOptionsData);
      break;

    case actions.PAGE_CHANGE:
      entityState.paging = payload;
      break;

    case actions.FILTERS_CHANGE:
      entityState.filters = payload;
      break;

    case actions.ENTITY_UNMOUNT:
      delete draft[entityId];
      break;

    default:
  }
}, {});